module.exports = "<div class=\"col-lg-12\">\n  <div class=\"main loading-modal\" *ngIf=\"!isClose\">\n    <div class=\"sweet-modal-overlay open\">\n      <div class=\"tradlinx-loading\">\n        <h2>{{ loadingMsg }}</h2>\n        <img src=\"/images/tradlinx_loading.gif\"/>\n      </div>\n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/loading/loading-modal.html
// module id = ./src/app/containers/loading/loading-modal.html
// module chunks = 1